import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './custom.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import UserProvider from './components/UserProvider';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') ?? undefined;

const root = ReactDOM.createRoot(
   document.getElementById('root') as HTMLElement
);

root.render(
   <React.StrictMode>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
         <BrowserRouter basename={baseUrl}>
            <UserProvider>
               <CssBaseline />
                  <App />
            </UserProvider>
         </BrowserRouter>
      </LocalizationProvider>
   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
